import { match } from 'ts-pattern';

import { AppSwitcher as LuterkortAppSwitcher } from '@ingrid/luterkort-react';
import { AppType } from '@ingrid/luterkort-react/dist/DropdownMenu/AppSwitcherComposite';

import { insertOnCondition } from '~src/utils/array';

import { usePermissions } from '../hooks/usePermissions';
import { useSite } from '../hooks/useSite';
import { APP_ROLES } from '../providers/PermissionProvider';
import { IMPRoute } from '../routes';

export function AppSwitcher() {
  const { hasRole } = usePermissions();
  const { merchant, site } = useSite();

  const madUrlParams = merchant?.id && site?.id ? `/merchants/${merchant.id}/sites/${site.id}` : '';
  const instoreUrlParams = site?.id ? `/${site.id}` : '';

  const apps = [
    ...insertOnCondition(hasRole(APP_ROLES.checkout), 'checkout' as const),
    ...insertOnCondition(hasRole(APP_ROLES.tracking), 'tracking' as const),
    ...insertOnCondition(hasRole(APP_ROLES.instore), 'instore' as const),
    ...insertOnCondition(hasRole(APP_ROLES.settings), 'settings' as const),
  ];

  function handleSelect(app: AppType) {
    window.location.href = match(app)
      .with('checkout', () => `${IMPRoute.CHECKOUT_APP}${madUrlParams}`)
      .with('tracking', () => `${IMPRoute.TRACKING_APP}${madUrlParams}`)
      .with('instore', () => `${IMPRoute.INSTORE_APP}${instoreUrlParams}`)
      .with('settings', () => `${IMPRoute.SETTINGS_APP}${madUrlParams}`)
      .otherwise(() => {
        throw new Error(`There's no link configured for ${app} yet.`);
      });
  }

  return (
    <div style={{ marginLeft: 'auto' }}>
      <LuterkortAppSwitcher onSelect={handleSelect} apps={apps} />
    </div>
  );
}
